// Icons
import { TreeEvergreen, Moon, ArrowRight } from "phosphor-react";

// Components
import Button from "../../General/Components/Button";

// Other
import React from "react";
import { Link } from "react-router-dom";

// Custom Hooks
import useLogOut from "../../../Hooks/Authentication/useLogOut";

const MemberNavbar = () => {
  const logOut = useLogOut();

  const handleLogout = () => {
    logOut();
  };

  return (
    <nav className="h-16 mb-0 w-[98%] flex justify-between font-brand items-center bg-dark-700 z-10 mobile:text-center ">
      {/* Left Section */}
      <Link to="/redirect" className="flex items-center font-bold z-20">
        {/* Brand Icon */}
        <TreeEvergreen
          size={30}
          color="#009fff"
          weight="bold"
          className="mr-1.5"
        />
        <span>Mirelise</span>
      </Link>

      <ul className={"flex items-center font-semibold"}>
        {/* Theme Toggle */}
        <Moon
          size={25}
          color="#009fff"
          weight="bold"
          className="cursor-pointer mr-5"
        />

        <Button action={handleLogout} title="Log out" Icon={ArrowRight} />
      </ul>
    </nav>
  );
};

export default MemberNavbar;
